module.exports = __webpack_public_path__ + "static/img/12.3ce1451.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/12.svg
// module id = 574
// module chunks = 1